import { AvoPageName } from "@shared/types";
import { HOT_TRADES_HELPER_DESCRIPTION } from "@shared/common/constants";
import { INCLUDE_NEW_SYMBOLS_TITLE } from "@shared/features/bots/BotForm/common/constants";

export const FREE_TEXT_HELPER_TOOLTIP = {
  description:
    "You can insert a basic free text command (like the template below) and all the details for the trade will be populated accordingly; there are also additional commands our free text trade creation supports",
  articleLink:
    "https://intercom.help/cornix/en/articles/5814928-free-text-trade",
  avoPageName: AvoPageName.CREATE_TRADE,
  avoFieldName: "Free Text",
};
export const ENTRIES_HELPER_TOOLTIP = {
  avoFieldName: "Entry Strategy",
  description:
    "The entry strategy will determine how the amount will be divided between the different entry targets for the trade.",
  articleLink:
    "https://intercom.help/cornix/en/articles/5814861-entry-strategy",
  avoPageName: AvoPageName.CREATE_TRADE,
};
export const TAKE_PROFITS_HELPER_TOOLTIP = {
  avoFieldName: "Take-Profit Strategy",
  description:
    "The take-profit strategy will determine how the total allocated amount for the trade will be divided between the take-profit targets",
  articleLink:
    "https://intercom.help/cornix/en/articles/5814868-take-profit-strategy",
  avoPageName: AvoPageName.CREATE_TRADE,
};
export const STOP_HELPER_TOOLTIP = {
  avoFieldName: "Stop Loss strategy",
  description:
    "Setting a stop-loss helps you mitigate the amount of risk you wish to take in your trade. This setting will determine at what price you would close your trade at a loss.",
  articleLink: "",
  avoPageName: AvoPageName.CREATE_TRADE,
};
export const TRAILING_CREATE_TRADE_HELPER_TOOLTIP = {
  avoFieldName: "Trailing",
  description:
    "The trailing setting is a sophisticated feature that allows you to set a conditional order that moves/follows the market price after the trigger price was reached",
  articleLink: "https://intercom.help/cornix/en/articles/5814927-trailing",
  avoPageName: AvoPageName.CREATE_TRADE,
};
export const ACCOUNT_TRADING_CONFIGURATION_HELPER_TOOLTIPS = {
  "Auto-Trading Filters": {
    avoFieldName: "Auto-Trading Personal Thresholds and Blacklists",
    description:
      "In this section you can control which trades will be excluded, when auto-trading is enabled, based on your preferences. If you wish to learn more click the link below",
    articleLink:
      "https://help.cornix.io/en/articles/7328829-auto-trading-filters",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
  General: {
    avoFieldName: "General Configuration Settings",
    description:
      "If you wish to learn more about the General Configuration Settings click the link below",
    articleLink: "https://help.cornix.io/en/articles/7328850-general-section",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
  Margin: {
    avoFieldName: "Margin Settings",
    description:
      "If you wish to learn more about the Margin Configuration Settings click the link below",
    articleLink: "https://help.cornix.io/en/articles/7328869-margin-section",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
  "Stop-loss": {
    avoFieldName: "Stop Loss strategy",
    description:
      "If you wish to learn more about the Stop-Loss Configuration Settings click the link",
    articleLink: "https://help.cornix.io/en/articles/7328885-stop-loss",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
  Strategies: {
    avoFieldName: "Strategies",
    description:
      "If you wish to learn more about the Strategies Configuration Settings click the link below",
    articleLink:
      "https://help.cornix.io/en/articles/7328903-strategies-section",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
  Trailing: {
    avoFieldName: "Trailing",
    description:
      "Set your default trailing settings. The trailing setting is a sophisticated feature that allows you to set a conditional order that moves/follows the market price after the trigger price was reached",
    articleLink: "https://help.cornix.io/en/articles/7328920-trailing-section",
    avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  },
};
export const GROUPS_HELPER_TOOLTIP = {
  avoFieldName: "Groups",
  avoPageName: AvoPageName.ACCOUNTS_AND_GROUPS,
  description:
    "Signals groups you're a member of and that are integrated with Cornix",
};
export const HOT_TRADES_HELPER_TOOLTIP = {
  avoPageName: "Dashboard",
  avoFieldName: "Hot Trades",
  description: HOT_TRADES_HELPER_DESCRIPTION,
};
export const TRADES_PROGRESS_HELPER_DESCRIPTION = {
  topSection: "The graph indicates the progress of the trade.",
  ul: [
    "The green color indicates the ratio between the amount filled and the amount allocated to the trade.",
    "The orange indicates the ratio between the amount sold and the amount that potentially will be sold.",
    "In the center of the graph, you can see your current loss or profit as a percentage and how long the trade has been active.",
  ],
};
export const TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP = {
  avoPageName: "Trade Extra Details",
  avoFieldName: "Waiting for cancel verification",
  description:
    "Cornix has placed the respective orders to close the trade and is awaiting for a response from the exchanges' that the positions have been closed.",
};
export const CANCEL_ON_TP_REACHED_HELPER_TOOLTIP = {
  avoPageName: AvoPageName.TRADING_TERMINAL,
  avoFieldName: "Cancel on first TP target reached",
  description:
    "This option will determine whether or not the trade will close if the first take-profit target is reached before any of the entry targets are reached.",
};
export const INCLUDE_NEW_SYMBOLS_TOOLTIP = {
  avoPageName: AvoPageName.BOT_FORM,
  avoFieldName: INCLUDE_NEW_SYMBOLS_TITLE,
  description:
    "When enabled, newly listed exchange symbols will be added to the bot's allowed symbols list and trades will be created for them.",
};
